export default function stripHtml(string: string) {
	if (!string) {
		return string;
	}
	return string.replace(/<[^>]*>?/gm, '');
}
